import WordCloudWidget from './WordCloudWidget';
export default WordCloudWidget;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/components/WordCloudWidget/index.js